import styled from 'styled-components';

const Textarea = styled.textarea`
    border: 0!important;
    border-radius: 4px!important;
    padding: 12px 16px!important;
    margin: 8px 0!important;
    outline: none;
    background-color: #f5f5f5;
    ::placeholder {
        color: #999;
    }
`;

export default Textarea;
